import { useNavigate } from "react-router-dom"
import "../styles/portal/Trabalhos.css"
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useContext, useEffect, useState } from "react";
import { PortalContext } from "../Portal";
import { getDevicesFieldsAPI, getFieldEventsAPI } from "../aws/Api";
import Botao from "../utils/Botao";

function Trabalhos() {
    const navigate = useNavigate();
    const { devices, 
        setEventoEscolhido, 
        startDate, 
        setStartDate, 
        endDate, 
        setEndDate, 
        options, 
        setOptions,
        optionsCampo,
        setOptionsCampo,
        selectedDevices, 
        setSelectedDevices,
        selectedCampos, 
        setSelectedCampos,
        setCampoEscolhido
    } = useContext(PortalContext);
    // const [selectedDevices, setSelectedDevices] = useState([]);
    // const [selectedCampos, setSelectedCampos] = useState([]);
    // const [optionsCampo, setOptionsCampo] = useState();
    const [eventos, setEventos] = useState([]);

    useEffect(() => {
        // console.log("devices = ", devices);
        
        if (devices != null) {
            setOptions(devices.map((device) => ({value: device.deviceID, label: device.deviceName})))
        }
        // console.log("options = ", options);

        if (selectedDevices && selectedCampos && startDate && endDate)
            handleOnClickFiltrar();
    },[]);
    const handleOnClickVoltar = () => {
        navigate("/portal/home");
    }
    /* const options = [
        {value: "xxx", label: "tablet01 (id:xxxx)"},
        {value: "yyy", label: "tablet02 (id:yyy)"},
        {value: "zzz", label: "tablet03 (id:zzz)"}
    ]; */
    const handleChangeDevices = (selectedItems) => {
        setSelectedDevices(selectedItems);
        // console.log(selectedItems);
        updateTalhoesDisponiveis(selectedItems);
    }
    const updateTalhoesDisponiveis = (selectedItems) => {
        // 1. Crie um array de Promises a partir das suas chamadas de API
        // console.log("Funcao updateTalhoesDisponiveis");
        const promises = selectedItems.map(devs => {
        return getDevicesFieldsAPI(devs.value);
        });

        // 2. Use Promise.all para esperar que todas as chamadas terminem
        Promise.all(promises)
        .then(responses => {
            // 'responses' é um array de objetos 'Response'
            // Agora, mapeamos cada resposta para converter o body em JSON
            const jsonPromises = responses.map(response => {
                if (!response.ok) {
                    // Se uma das requisições falhar, você pode lançar um erro específico
                    // Aqui, a Promise.all vai falhar e cair no .catch()
                    throw new Error(`Não conseguiu buscar campos deste deviceID. Status: ${response.status}`);
                }
                return response.json();
            });

            // Promise.all para esperar que todas as conversões para JSON terminem
            return Promise.all(jsonPromises);
        })
        .then(results => {
            // 'results' será um array de arrays, cada um contendo o JSON de uma resposta
            // console.log('Resultados de todas as APIs:', results);

            // 3. Combine todos os arrays de resultados em um só
            const arrayFinal = results.flat(); 
            // console.log('Array final e completo:', arrayFinal);

            if (arrayFinal != null) {
                const arrayDeOpcoes = arrayFinal.map((talhao) => ({value: talhao.campoUUID, label: talhao.campoNome, latRef: talhao.latReferencia, lonRef: talhao.lonReferencia}))
                // console.log("arrayDeOpcoes ", arrayDeOpcoes)
                setOptionsCampo(arrayDeOpcoes);
            }
        })
        .catch(error => {
            console.error("Uma das chamadas de API falhou:", error);
        });
    }
    const handleChangeTalhoes = (selectedItems) => {
        setSelectedCampos(selectedItems);
        // console.log(selectedItems);
    }
    const handleOnClickFiltrar = () => {
        // console.log("Pressionou filtrar, data start = ", startDate, ", data fim = ", endDate, " e com array de campos = ", selectedCampos);
        // return;
        // 1. Crie um array de Promises a partir das suas chamadas de API
        const promises = selectedCampos.map(talhao => {
            // console.log("Chamando fielsEventsAPI com campouuid", talhao.value)
            return getFieldEventsAPI(talhao.value);
        });

        // 2. Use Promise.all para esperar que todas as chamadas terminem
        Promise.all(promises)
        .then(responses => {
            // 'responses' é um array de objetos 'Response'
            // Agora, mapeamos cada resposta para converter o body em JSON
            const jsonPromises = responses.map(response => {
                if (!response.ok) {
                    // Se uma das requisições falhar, você pode lançar um erro específico
                    // Aqui, a Promise.all vai falhar e cair no .catch()
                    throw new Error(`Não conseguiu buscar campos deste deviceID. Status: ${response.status}`);
                }
                return response.json();
            });

            // Promise.all para esperar que todas as conversões para JSON terminem
            return Promise.all(jsonPromises);
        })
        .then(results => {
            // 'results' será um array de arrays, cada um contendo o JSON de uma resposta
            // console.log('Resultados de todas as APIs:', results);

            // 3. Combine todos os arrays de resultados em um só
            const arrayFinal = results.flat(); 
            // console.log('Array final e completo:', arrayFinal);

            if (arrayFinal != null) {
                // const arrayDeOpcoes = arrayFinal.map((talhao) => ({value: talhao.campoUUID, label: talhao.campoNome}))
                // console.log("arrayDeOpcoes ", arrayDeOpcoes)
                // setEventos(arrayDeOpcoes);
                filtraEventosPorData(arrayFinal);
            }
        })
        .catch(error => {
            console.error("Uma das chamadas de API falhou:", error);
        });
    }
    const filtraEventosPorData = (arrayEventos) => {
        // 1. Zere as horas das datas para comparar apenas o dia
        // Isso evita problemas com a hora exata da criação das datas
        startDate.setHours(0, 0, 0, 0);
        endDate.setHours(23, 59, 59, 999); // Inclui todo o dia de endDate

        // 2. Use o método filter() para criar o novo array
        const eventosNoIntervalo = arrayEventos.filter(evento => {
            let dataDoEvento = new Date();
            if (!evento.data) {
                console.log("Evento não possui data");
            } else {

                const partesDaData = evento.data.split('/');
                const dia = parseInt(partesDaData[0], 10);
                const mes = parseInt(partesDaData[1], 10) - 1; // O mês é baseado em 0 (janeiro é 0, fevereiro é 1, etc.)
                const ano = parseInt(partesDaData[2], 10);
                
                // 2. Cria um novo objeto Date
                dataDoEvento = new Date(ano, mes, dia);
            }
            // Garante que a data do evento também seja comparada sem as horas
            dataDoEvento.setHours(0, 0, 0, 0);
             console.log("data deste evento ", dataDoEvento);
            // 3. A condição de verificação: a data do evento deve ser >= startDate E <= endDate
            return dataDoEvento >= startDate && dataDoEvento <= endDate;
        });
         console.log("novoArray = ", eventosNoIntervalo);
        setEventos(eventosNoIntervalo);
    }
    const handleOnClickEvento = (evento) => {
        // console.log(evento);
        optionsCampo.map((campo) => {
            if (campo.value === evento.campoUUID) {
                setCampoEscolhido(campo);
                // console.log("campo certo é o campo ", campo);
            }
            // else {
            //     console.log("campo não é o mesmo, pois campo = ", campo.value, ", e eventoEscolhido.campoUUID = ", evento.campoUUID);
            // }
        })
        navigate("/portal/trabalho-detalhe")
        setEventoEscolhido(evento);
    }
    return (
        <div className="trabalhos-main-container">
            <div className="trabalhos-tittle-container">
                <Botao handleOnClick={() => handleOnClickVoltar()} estilo={{width: "100px"}}>Voltar</Botao>
                {/* <button className="trabalhos-tittle-btnvoltar" onClick={() => handleOnClickVoltar()}>Voltar</button> */}
                <div className="tittle">Meus Trabalhos</div>
            </div>
            <div className="trabalhos-content-container">
                <div className="trabalhos-content-filter">
                    <div className="trabalhos-content-filter-dropdown">
                        <h3>Device:</h3>
                        <Select options={options} onChange={handleChangeDevices} value={selectedDevices} isMulti/>
                    </div>
                    <div className="trabalhos-content-filter-dropdown">
                        <h3>Talhoes:</h3>
                        <Select options={optionsCampo} onChange={handleChangeTalhoes} isMulti value={selectedCampos}/>
                    </div>
                    <div className="trabalhos-content-filter-dropdown">
                        <h3>Data Início:</h3>
                        <DatePicker selected={startDate} onChange={(date) => setStartDate(date)} />
                    </div>
                    <div className="trabalhos-content-filter-dropdown">
                        <h3>Data Fim:</h3>
                        <DatePicker selected={endDate} onChange={(date) => setEndDate(date)} />
                    </div>
                    <div className="trabalhos-content-filter-filtrarbtn">
                        <Botao handleOnClick={() => handleOnClickFiltrar()} estilo={{"max-width": "125px", "min-height": "75px"}}>Filtrar</Botao>
                        {/* <button onClick={() => handleOnClickFiltrar()}>Filtrar</button> */}
                    </div>
                </div>
                <div className="trabalhos-content-result">
                    {eventos.map(( evento ) => (
                    <div className="trabalhos-content-result-unidade-container" onClick={() => handleOnClickEvento(evento)} key={evento.eventoUUID}>
                        <span>{evento.eventoNome}</span>
                        <p>{evento.areaAplicadaTotal} ha</p>
                    </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default Trabalhos
